import { Button, Flex } from '@iheartjane/reefer';
import { clsx } from 'clsx';

import { useStoreSwitcher } from '@jane/bloom/hooks/storeSwitcher/useStoreSwitcher';
import { useCustomLanguage } from '@jane/bloom/hooks/useCustomLanguage';

import styles from './storeSwitcherForm.module.css';

export function StoreSwitcherReservationModes() {
  const customLanguage = useCustomLanguage();

  const {
    deliveryStores,
    handleSearchReservationModeChanged,
    pickupStores,
    searchReservationMode,
  } = useStoreSwitcher();

  if (deliveryStores.length === 0 || pickupStores.length === 0) {
    return null;
  }

  return (
    <Flex flexDirection="row" gap={8} justifyContent="center">
      <Button
        className={clsx(styles['formButton'], {
          [styles['formButton--disabled']]: pickupStores.length === 0,
        })}
        full
        data={{ selected: searchReservationMode === 'pickup' }}
        label={customLanguage.reservationModeLabels.pickup || 'Pickup'}
        subLabel={pickupStores.length === 0 ? 'Unavailable' : ''}
        onClick={() => {
          handleSearchReservationModeChanged('pickup');
        }}
        disabled={pickupStores.length === 0}
      />

      <Button
        className={clsx(styles['formButton'], {
          [styles['formButton--disabled']]: deliveryStores.length === 0,
        })}
        full
        data={{ selected: searchReservationMode === 'delivery' }}
        label={customLanguage.reservationModeLabels.delivery || 'Delivery'}
        subLabel={deliveryStores.length === 0 ? 'Unavailable' : ''}
        onClick={() => {
          handleSearchReservationModeChanged('delivery');
        }}
        disabled={deliveryStores.length === 0}
      />
    </Flex>
  );
}
